import { createChallengePlayerLink } from '@infl-ts/util-use-challenge-player';
import { constVoid, pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import { parse } from 'qs';
import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';

const CHALLENGE_UUID = 'challenge_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}';
const CHALLENGE_PAGE = '^/challenges/' + CHALLENGE_UUID + '$';

const UrlTransformer = () => {
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const path = location.pathname;
    if (!path.match(CHALLENGE_PAGE)) return;

    pipe(
      path.match(CHALLENGE_UUID),
      O.fromNullable,
      O.map(matches => matches[0]),
      O.map(uuid =>
        createChallengePlayerLink(
          `/challenges`,
          { uuid },
          parse(location.search, { ignoreQueryPrefix: true })
        )
      ),
      O.match(constVoid, newChallengeLink => history.replace(newChallengeLink))
    );
  }, [location, history]);

  return null;
};

export default UrlTransformer;
